var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoilGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5H2V7H22V5Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H2V15H4V13Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9H6V11H4V9Z",
    fill: "#696F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H4V19H6V17Z",
    fill: "#696F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10V13Z",
    fill: "#696F88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H12V11H14V9Z",
    fill: "#696F88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H14V19H12V17Z",
    fill: "#696F88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13H18V15H20V13Z",
    fill: "#696F88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H22V11H20V9Z",
    fill: "#696F88"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H20V19H22V17Z",
    fill: "#696F88"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H8V15H6V13Z",
    fill: "#696F88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H8V11H10V9Z",
    fill: "#696F88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H10V19H8V17Z",
    fill: "#696F88"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H14V15H16V13Z",
    fill: "#696F88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9H18V11H16V9Z",
    fill: "#696F88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H16V19H18V17Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoilGray);
export default __webpack_public_path__ + "static/media/soil-gray.e7ab3f395594bcad546132ae2f094571.svg";
export { ForwardRef as ReactComponent };